import { Grid, Typography, Box } from '@mui/material'
import Image from '../../atoms/Image/Image'
//styles
import { useStyles } from './CurrentLoanDetailsStyles'

const CurrentLoanDetails = ({ Icon, Key, Value, children }) => {
  const classes = useStyles()

  return (
    <Box className={classes.detailsWrapper}>
      <Grid
        container
        spacing={1}
        alignItems={'flex-start'}
        className={classes.detailsContainer}
      >
        <Grid item xs={1} sm={1} className={classes.iconContainer}>
          <Image src={Icon} className={classes.detailIcon} />
        </Grid>
        <Grid item xs={4} sm={5} className={classes.keyContainer}>
          <Typography
            className={classes.CustomTypoKey}
          >
            {Key}
          </Typography>
        </Grid>
        <Grid item xs={7} sm={6} className={classes.valueContainer}>
          {Value && (<Typography className={classes.CustomTypoValue}>{Value}</Typography>)}
          {children && <div className={classes.childrenContainer}>{children}</div>}
        </Grid>
      </Grid>
    </Box>
  )
}

export default CurrentLoanDetails
